module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/act/sections/ai/assets/ai_tutor_feature-3d37a8d55a8a9481b7a0f49aecca3fc3.png";